import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Database } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/data/postgres')({
  component: PostgresViewerPage,
});

function PostgresViewerPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">PostgreSQL Viewer</h1>
        <p className="text-muted-foreground">Browse and query PostgreSQL database</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="h-5 w-5" />
            PostgreSQL
          </CardTitle>
          <CardDescription>Database browser and query interface</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">PostgreSQL viewer coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
